import { render, staticRenderFns } from "./VarientRating.vue?vue&type=template&id=44796ed6"
import script from "./VarientRating.vue?vue&type=script&lang=js"
export * from "./VarientRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports